import React from 'react';
import { ChevronDown } from 'lucide-react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';
import { stringHueColor } from '../../utils/workspaceFormat';

function initials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  const one = parts[0] || '?';
  return one.slice(0, 2).toUpperCase();
}

export default function ContactsPage() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const contacts = data?.contacts || [];
  const n = contacts.length;

  return (
    <MainPanel
      title={t('contacts.title')}
      actions={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <input
            type="search"
            placeholder={t('shell.searchPlaceholder')}
            className="custio-field__input"
            style={{ maxWidth: 200, background: '#1f2229', color: '#fff' }}
          />
          <button type="button" className="custio-btn-primary" style={{ borderRadius: 999 }}>
            {t('contacts.message')}
          </button>
        </div>
      }
    >
      {contacts.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{t('contacts.emptyTitle')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>{t('contacts.emptyBody')}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {contacts.map((c) => (
            <div
              key={c.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                padding: '16px 20px',
                background: '#1f2229',
                borderRadius: 12,
                color: '#fff',
                border: '1px solid rgba(255,255,255,0.06)',
              }}
            >
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: '50%',
                  background: stringHueColor(c.email || c.fullName),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                }}
              >
                {initials(c.fullName)}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700 }}>{c.fullName}</div>
                <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 4 }}>{c.email}</div>
                {c.phone && <div style={{ fontSize: 13, color: '#9ca3af' }}>{c.phone}</div>}
                <button
                  type="button"
                  style={{ marginTop: 8, background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 13 }}
                >
                  {t('contacts.viewDetails')}
                </button>
              </div>
              <ChevronDown size={20} color="#6b7280" />
            </div>
          ))}
        </div>
      )}
      {contacts.length > 0 && (
        <div
          style={{
            marginTop: 24,
            padding: '12px 20px',
            background: '#1f2229',
            borderRadius: 12,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: 13,
            color: '#9ca3af',
          }}
        >
          <span>{t('contacts.showing', { from: 1, to: n, total: n })}</span>
          <span>{t('contacts.pageOf', { current: 1, total: 1 })}</span>
        </div>
      )}
    </MainPanel>
  );
}
